import {OrderOptions} from '../models/Common';
import {MetricsFilter} from '../models/Metric';

export enum MetricsActionType {
    UPDATE_ORDER_METRICS = 'UPDATE_ORDER_METRICS',
    UPDATE_METRICS_FILTER = 'UPDATE_UPDATE_METRICS_FILTERMETRICS_PERIOD',
}

export const updateOrderMetrics = (orderParams: OrderOptions) => (dispatch: any) => {
    dispatch({
        type: MetricsActionType.UPDATE_ORDER_METRICS,
        orderParams
    });
};

export const updateMetricsFilter = (metricsFilter: MetricsFilter) => (dispatch: any) => {
    dispatch({
        type: MetricsActionType.UPDATE_METRICS_FILTER,
        metricsFilter
    });
};
